module.exports = new __parcel__URL__("welcome-to-project-pages.5dd7820d.svg").toString();